
export const generateYearOptions = () => {
  const start = 2010;
  const end = 1940;
  const rangeArray = Array.from({ length: start -end - 1 }, (_, i) => start - i);

  let options:any = [];
    rangeArray.map((option) => {
      options.push({ label: String(option), value: option });
    });
  return options;
};

export const generateDayOptions = ( month: any) => {
	const year = 2025;
    const daysInMonth = new Date(year, month, 0).getDate();
    const rangeArray = Array.from({ length: daysInMonth }, (_, i) => i+1);

    let options:any = [];
    rangeArray.map((option) => {
      const val =  String(option).padStart(2, '0');
      options.push({ label: String(val), value: val });
    });

    return options;
  };

